import React, { useEffect, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { FaAngleLeft, FaExpeditedssl } from "react-icons/fa";
import flag_2 from "./../../assets/img/tarh-parcham-iran-psdtarh2.png";
import MainLayout from "../../layout/main";
import Pagination from "../../component/pagination";
import { ApiEndpoints, useApiCall } from "../../api";
import Loading from "../../component/loading";
import { toDateString } from "../../helper/dateHelper";
import { useTableDataGenerator } from "../../helper/common";
import { appRoutes, useAppNavigation } from "../../router/routes";
import { useRoleSelector } from "../../helper/roleHelper";
import { UserRoles } from "../../storage/enums";
import { RoleViewSelector } from "../../component/roleViewSelector";
import { confirmAlert } from "react-confirm-alert";
import { Table } from "../../component/table";
import { SelectOption } from "../../component/selectOption";
import { storageApi } from "../../storage/storageApi";
import { LIST_PAGE_SIZE } from "../../config";

const ProgramListPage = () => {
  const { navigate, queryParameter } = useAppNavigation();

  const [searchProgramName, setSearchProgramName] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [searchUserType, setSearchUserType] = useState("USER_NAME");
  const [status, setStatus] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [department, setDepartment] = useState("");
  const [sazman, setSazman] = useState("");
  const eventId = queryParameter().get("eventId");
  const [monasebat, setMonasebat] = useState("");
  const [onvanBarname, setOnvanBarname] = useState("");
  const userId = queryParameter().get("userId");
  const [queryUserId, setQueryUserId] = useState(
    queryParameter().get("userId"),
  );
  const [majmooe, setMajmooe] = useState();
  const [cPage, setCPage] = useState(queryParameter().get("page"));
  const removeFilters = () => {
    window.location.reload();
    // setSearchProgramName("");
    // setSearchUser("");
    // setSearchUserType("USER_NAME");
    // setStatus("");
    // setCity("");
    // setDepartment("");
    // setSazman("");
    // setMonasebat("");
  };
  useEffect(() => {
    handleGetPrograms();
  }, []);
  const handleGetPrograms = () => {
    programsObj = fetchPrograms();
  };
  const endpoints = useRoleSelector({
    [UserRoles.Admin]: ApiEndpoints.program.listByAdmin,
    [UserRoles.Sazman]: ApiEndpoints.program.listByAdmin,
    [UserRoles.SazmanOstan]: ApiEndpoints.program.listByAdmin,
    [UserRoles.ModireKol]: ApiEndpoints.program.listByAdmin,
    [UserRoles.User]: ApiEndpoints.program.list,
  });

  const cityDepartmentIsLazy = useRoleSelector({
    [UserRoles.Admin]: false,
    [UserRoles.Sazman]: false,
    [UserRoles.SazmanOstan]: false,
    [UserRoles.ModireKol]: false,
    [UserRoles.User]: false,
  });

  const userProfile = storageApi.useGetUser();

  const isAdmin = () => {
    return userProfile.role == "state_manager";
  };
  const isSazman = () => {
    return userProfile.role == "organization_manager";
  };
  const isSazmanOstan = () => {
    return userProfile.role == "state_organization_manager";
  };
  const isModireKol = () => {
    return userProfile.role == "admin";
  };
  // const [[stateList, departmentList]] = useApiCall({
  //   endpoints: [ApiEndpoints.user.stateList, ApiEndpoints.user.departmentList],
  //   lazy: cityDepartmentIsLazy,
  // });

  const [[cityList, departmentList]] = useApiCall({
    endpoints: [ApiEndpoints.user.cityList, ApiEndpoints.user.departmentList],
    lazy: cityDepartmentIsLazy,
  });

  const [[monasebatList]] = useApiCall({
    endpoints: [ApiEndpoints.events.list],
    lazy: cityDepartmentIsLazy,
  });

  const [[programNameList]] = useApiCall({
    endpoints: [ApiEndpoints.docs.programNameList],
  });
  const [[stateList]] = useApiCall({
    endpoints: [ApiEndpoints.user.stateList],
  });

  const [[sazmanList]] = useApiCall({
    endpoints: [ApiEndpoints.user.organizationList],
    lazy: cityDepartmentIsLazy,
  });

  const [[profile]] = useApiCall({
    endpoints: [ApiEndpoints.user.profile],
    lazy: cityDepartmentIsLazy,
  });
  let [[programsObj], { fetch: fetchPrograms, loading: listLoading }] =
    useApiCall({
      endpoints,
      payload: {
        user_id: queryUserId,
        page: cPage,
        search: searchUser,
        status: status,
        monasebat: monasebat,
        user_city: city,
        onvan_barnameh: onvanBarname,
        user_majmooe: department,
        user_sazman: sazman,
        state: state,
      },
      lazy: true,
    });
  const [[selectedUser], { loading: loadingUser }] = useApiCall({
    endpoints: ApiEndpoints.user.listByAdmin,
    payload: {
      user_id: userId,
    },
    lazy: !userId,
  });
  useEffect(() => {
    if (
      profile &&
      (userProfile.role === "state_organization_manager" ||
        userProfile.role === "organization_manager")
    ) {
      setMajmooe(profile?.data.department);
    }
  }, [profile]);
  useEffect(() => {
    if (!loadingUser) {
      setSearchUser(selectedUser?.data?.[0]?.mobile_number);
      setSearchUserType(searchUserType);
    }
  }, [loadingUser]);
  useEffect(() => {
    console.log(queryUserId);
  }, [queryUserId]);
  const [, { loading: deleteLoading, fetch: programDeleteApi }] = useApiCall({
    endpoints: ApiEndpoints.program.delete,
    lazy: true,
  });

  const loading = deleteLoading || listLoading;
  let filters = {};

  const { data, setPage, currentPage, totalPageCount } = useTableDataGenerator(
    programsObj?.data?.data ?? [],
    {
      filters,
    },
    programsObj?.data.count,
  );
  const setTablePage = (pageNumber) => {
    setCPage(pageNumber + 1);
  };
  useEffect(() => {
    if (eventId && eventId !== "") {
      console.log(eventId);
      setMonasebat(+eventId);
    }
  }, [eventId]);
  useEffect(() => {
    if (
      status !== "" ||
      state !== "" ||
      monasebat !== "" ||
      city !== "" ||
      department !== "" ||
      sazman !== "" ||
      onvanBarname !== "" ||
      queryUserId !== ""
    ) {
      setTablePage(0);
      if (cPage === 1) {
        handleGetPrograms();
      }
    }
  }, [
    status,
    monasebat,
    city,
    department,
    sazman,
    onvanBarname,
    queryUserId,
    state,
  ]);
  useEffect(() => {
    console.log(cPage);
    if (cPage > 0) {
      handleGetPrograms();
    }
  }, [cPage]);
  const onProgramDeleteClick = (item) => {
    confirmAlert({
      title: "",
      message: "آیا از حذف برنامه مطمئن هستید ؟",
      buttons: [
        {
          label: (
            <div>
              بله
              <Loading isLoading={loading} />
            </div>
          ),
          onClick: async () => {
            const [{ isOk }] = await programDeleteApi({
              programId: item.id,
            });
            if (isOk) {
              window.location.reload();
            }
          },
        },
        {
          label: "خیر",
          onClick: () => {},
        },
      ],
    });
  };

  const onProgramClickByAdmin = (item) => {
    navigate(appRoutes.programDetail(item.id));
  };
  const onProgramClickBySazman = (item) => {
    navigate(appRoutes.programDetail(item.id));
  };
  const onProgramClickByUser = (item) => {
    if (
      toDateString(item.implementation_date, "jYYYY/jMM/jDD") >
      toDateString(new Date(), "jYYYY/jMM/jDD")
    ) {
      navigate(appRoutes.programEdit(item.id));
    } else {
      navigate(appRoutes.programEditReport(item.id));
    }
  };

  const tableHeader = useRoleSelector({
    [UserRoles.User]: [
      {
        name: "ردیف",
        width: 1,
        render: (i) =>
          cPage === null
            ? i.rowIndex
            : i.rowIndex + (cPage - 1) * LIST_PAGE_SIZE,
      },
      {
        name: "عنوان برنامه",
        width: 3,
        render: (i) => i.onvan_barnameh,
      },
      {
        name: "عنوان مناسبت",
        width: 3,
        render: (i) => i.monasebat,
      },
      {
        name: "تاریخ اجرا",
        width: 1,
        render: (i) =>
          i.implementation_date === "-"
            ? "-"
            : toDateString(i.implementation_date, "jYYYY/jMM/jDD"),
      },
      {
        name: "وضعیت ثبت برنامه",
        width: 1,
        render: (i) => i.status,
      },
      {
        name: "امتیاز برنامه",
        width: 1,
        render: (i) => i.score,
      },
      {
        name: "عملیات",
        width: 2,
        render: (i) => (
          <div className={"w-full justify-around flex items-center"}>
            <div
              onClick={() => onProgramClickByUser(i)}
              className="max-w-[90%] cursor-pointer float-left gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl flex justify-center items-center"
            >
              ویرایش
              <FaAngleLeft />
            </div>
            <div
              onClick={() => onProgramDeleteClick(i)}
              className="max-w-[90%] cursor-pointer gap-1 bg-red-100 text-red-500 px-3 py-2 rounded-xl flex justify-center items-center"
            >
              حذف
              <FaAngleLeft />
            </div>
          </div>
        ),
      },
    ],
    [UserRoles.Admin]: [
      {
        name: "ردیف",
        width: 1,
        render: (i) =>
          cPage === null
            ? i.rowIndex
            : i.rowIndex + (cPage - 1) * LIST_PAGE_SIZE,
      },
      {
        name: "نام و نام خانوادگی",
        width: 2,
        render: (i) => i.user_full_name,
      },
      {
        name: "عنوان برنامه",
        width: 2,
        render: (i) => i.onvan_barnameh_title,
      },
      {
        name: "تاریخ اجرا",
        width: 1,
        render: (i) =>
          i.implementation_date === "-"
            ? "-"
            : toDateString(i.implementation_date, "jYYYY/jMM/jDD"),
      },
      {
        name: "شهر",
        width: 1,
        render: (i) => i.user_city,
      },
      {
        name: "مجموعه",
        width: 1,
        render: (i) => i.user_majmooe,
      },
      {
        name: "سازمان",
        width: 1,
        render: (i) => i.user_sazman,
      },
      {
        name: "وضعیت برنامه",
        width: 1,
        render: (i) => i.status,
      },
      {
        name: "امتیاز برنامه",
        width: 1,
        render: (i) => i.score,
      },
      {
        name: "عملیات",
        width: 1,
        render: (i) => (
          <div
            onClick={() => onProgramClickByAdmin(i)}
            className="cursor-pointer flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
          >
            مشاهده
            <FaAngleLeft />
          </div>
        ),
      },
    ],
    [UserRoles.Sazman]: [
      {
        name: "ردیف",
        width: 1,
        render: (i) =>
          cPage === null
            ? i.rowIndex
            : i.rowIndex + (cPage - 1) * LIST_PAGE_SIZE,
      },
      {
        name: "نام و نام خانوادگی",
        width: 2,
        render: (i) => i.user_full_name,
      },
      {
        name: "عنوان برنامه",
        width: 2,
        render: (i) => i.onvan_barnameh_title,
      },
      {
        name: "تاریخ اجرا",
        width: 1,
        render: (i) =>
          i.implementation_date === "-"
            ? "-"
            : toDateString(i.implementation_date, "jYYYY/jMM/jDD"),
      },
      {
        name: "شهر",
        width: 1,
        render: (i) => i.user_city,
      },
      {
        name: "استان",
        width: 1,
        render: (i) => i.user_state,
      },
      {
        name: "سازمان",
        width: 1,
        render: (i) => i.user_sazman,
      },
      {
        name: "وضعیت برنامه",
        width: 1,
        render: (i) => i.status,
      },
      {
        name: "امتیاز برنامه",
        width: 1,
        render: (i) => i.score,
      },
      {
        name: "عملیات",
        width: 1,
        render: (i) => (
          <div
            onClick={() => onProgramClickBySazman(i)}
            className="cursor-pointer flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
          >
            مشاهده
            <FaAngleLeft />
          </div>
        ),
      },
    ],
    [UserRoles.SazmanOstan]: [
      {
        name: "ردیف",
        width: 1,
        render: (i) =>
          cPage === null
            ? i.rowIndex
            : i.rowIndex + (cPage - 1) * LIST_PAGE_SIZE,
      },
      {
        name: "نام و نام خانوادگی",
        width: 2,
        render: (i) => i.user_full_name,
      },
      {
        name: "عنوان برنامه",
        width: 2,
        render: (i) => i.onvan_barnameh_title,
      },
      {
        name: "تاریخ اجرا",
        width: 1,
        render: (i) =>
          i.implementation_date === "-"
            ? "-"
            : toDateString(i.implementation_date, "jYYYY/jMM/jDD"),
      },
      {
        name: "شهر",
        width: 1,
        render: (i) => i.user_city,
      },
      {
        name: "مجموعه",
        width: 1,
        render: (i) => i.user_majmooe,
      },
      {
        name: "سازمان",
        width: 1,
        render: (i) => i.user_sazman,
      },
      {
        name: "وضعیت برنامه",
        width: 1,
        render: (i) => i.status,
      },
      {
        name: "امتیاز برنامه",
        width: 1,
        render: (i) => i.score,
      },
      {
        name: "عملیات",
        width: 1,
        render: (i) => (
          <div
            onClick={() => onProgramClickBySazman(i)}
            className="cursor-pointer flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
          >
            مشاهده
            <FaAngleLeft />
          </div>
        ),
      },
    ],
    [UserRoles.ModireKol]: [
      {
        name: "ردیف",
        width: 1,
        render: (i) =>
          cPage === null
            ? i.rowIndex
            : i.rowIndex + (cPage - 1) * LIST_PAGE_SIZE,
      },
      {
        name: "نام و نام خانوادگی",
        width: 1,
        render: (i) => i.user_full_name,
      },
      {
        name: "عنوان برنامه",
        width: 2,
        render: (i) => i.onvan_barnameh_title,
      },
      {
        name: "تاریخ اجرا",
        width: 1,
        render: (i) =>
          i.implementation_date === "-"
            ? "-"
            : toDateString(i.implementation_date, "jYYYY/jMM/jDD"),
      },
      {
        name: "استان",
        width: 1,
        render: (i) => i.user_state,
      },
      {
        name: "شهر",
        width: 1,
        render: (i) => i.user_city,
      },
      {
        name: "مجموعه",
        width: 1,
        render: (i) => i.user_majmooe,
      },
      {
        name: "سازمان",
        width: 1,
        render: (i) => i.user_sazman,
      },
      {
        name: "وضعیت برنامه",
        width: 1,
        render: (i) => i.status,
      },
      {
        name: "امتیاز برنامه",
        width: 1,
        render: (i) => i.score,
      },
      {
        name: "عملیات",
        width: 1,
        render: (i) => (
          <div
            onClick={() => onProgramClickBySazman(i)}
            className="cursor-pointer flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
          >
            مشاهده
            <FaAngleLeft />
          </div>
        ),
      },
    ],
  });

  // useEffect(() => {
  //   console.log(currentPage);
  //   if (isAdmin() && currentPage !== 0) {
  //     navigate(appRoutes.programList({ page: currentPage + 1 }));
  //     setCPage(currentPage + 1);
  //     handleGetPrograms();
  //   }
  // }, [currentPage]);
  const renderUserInfo = () => {
    const user = selectedUser?.data?.[0];
    if (user) {
      return `ی کاربر ${user?.full_name}`;
    }
    return "";
  };
  useEffect(() => {
    if (
      (isAdmin() || isSazman() || isSazmanOstan() || isModireKol()) &&
      searchUser !== ""
    ) {
      setTablePage(0);
      if (cPage === 1) {
        fetchPrograms();
      }
    }
  }, [searchUser]);
  const renderSearch = () => {
    if (userId) {
      return <></>;
      return (
        <>
          <input
            type="text"
            placeholder="عنوان برنامه را جستجو کنید..."
            className=" w-full p-4  border-2 border-gray-100 rounded-lg pr-10 pl-12"
            onChange={(e) => setSearchProgramName(e.target.value)}
          />
          <div className=" absolute top-[50%] -translate-y-[50%] text-gray-400 right-2">
            <RiSearchLine size={24} />
          </div>
        </>
      );
    }
    return (
      <>
        <div className={"flex w-full"}>
          <input
            type="text"
            placeholder="شماره تلفن یا نام کاربر را جستجو کنید..."
            className="flex p-4 w-full border-2 border-gray-100 rounded-l-lg pr-10 pl-12"
            onChange={(e) => setSearchUser(e.target.value)}
          />
          {/*<div*/}
          {/*  className=" bg-blue-500 absolute left-2 text-white p-3 top-[50%] -translate-y-[50%] md:px-8 px-3 rounded-lg md:text-base text-sm"*/}
          {/*>*/}
          {/*  جستجو*/}
          {/*</div>*/}
          <div className=" absolute top-[50%] -translate-y-[50%] text-gray-400 left-2">
            <RiSearchLine size={24} />
          </div>
        </div>
      </>
    );
  };
  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative md:p-8 p-4">
          <img src={flag_2} className=" absolute left-0 top-0 md:h-42 h-24" />
          <div className="flex flex-col gap-8 justify-center items-center md:w-[60%] w-full md:mt-0 mt-4 mx-auto">
            <div>
              <div className="md:text-3xl text-xl text-center font-bold">
                <span className=" text-greenblue">
                  {UserRoles.Admin ||
                  UserRoles.Sazman ||
                  UserRoles.ModireKol ||
                  UserRoles.SazmanOstan ? (
                    <> فهرست برنامه‌ها</>
                  ) : (
                    <>برنامه ها{renderUserInfo()}</>
                  )}
                </span>
              </div>
            </div>
            <RoleViewSelector>
              <div className=" w-full space-y-3" userRole={UserRoles.User}>
                <div className="relative form-field">
                  {/*<input*/}
                  {/*  type="text"*/}
                  {/*  placeholder="عنوان برنامه را جستجو کنید..."*/}
                  {/*  className=" w-full p-4  border-2 border-gray-100 rounded-lg pr-10 pl-12"*/}
                  {/*  onChange={(e) => setSearchProgramName(e.target.value)}*/}
                  {/*/>*/}
                  {/*<div*/}
                  {/*  className=" bg-blue-500 absolute left-2 text-white p-3 top-[50%] -translate-y-[50%] md:px-8 px-3 rounded-lg md:text-base text-sm"*/}
                  {/*>*/}
                  {/*  جستجو*/}
                  {/*</div>*/}
                  {/*<div className=" absolute top-[50%] -translate-y-[50%] text-gray-400 right-2">*/}
                  {/*  <RiSearchLine size={24} />*/}
                  {/*</div>*/}
                </div>
                <div className="flex justify-center flex-wrap md:flex-nowrap">
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"عنوان برنامه:"}
                    value={onvanBarname}
                    options={programNameList?.data.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setOnvanBarname(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"عنوان مناسبت:"}
                    value={monasebat}
                    options={monasebatList?.data.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setMonasebat(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"وضعیت"}
                    value={status}
                    options={[
                      { label: "انتظار بررسی", value: "انتظار بررسی" },
                      { label: "نیاز به ویرایش", value: "نیاز به ویرایش" },
                      { label: "تایید شده", value: "تایید شده" },
                      { label: "در انتظار اجرا", value: "در انتظار اجرا" },
                    ]}
                    onChange={(e) => {
                      setStatus(e.value);
                    }}
                  />
                </div>
                <div className={"w-full justify-around items-center flex"}>
                  <button
                    onClick={removeFilters}
                    className="cursor-pointer flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                  >
                    حذف فیلترها x
                  </button>
                </div>
              </div>
              <div className=" w-full space-y-3" userRole={UserRoles.Admin}>
                <div className="relative form-field w-full flex items-center justify-center">
                  {renderSearch()}
                </div>
                {/* <div className={"w-full justify-around items-center flex"}>
                  <select
                    onChange={(e) => setStatus(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="month" value="">
                      همه وضعیت ها
                    </option>
                    <option name={"انتظار بررسی"} value={"انتظار بررسی"}>
                      انتظار بررسی
                    </option>
                    <option name={"نیاز به ویرایش"} value={"نیاز به ویرایش"}>
                      نیاز به ویرایش
                    </option>
                    <option name={"تایید شده"} value={"تایید شده"}>
                      تایید شده
                    </option>
                  </select>

                  <select
                    onChange={(e) => setDepartment(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="month" value="">
                      همه مجموعه
                    </option>
                    {departmentList?.data?.map((c) => (
                      <option name={c.title} value={c.title}>
                        {c.title}
                      </option>
                    ))}
                  </select>

                  <select
                    onChange={(e) => setState(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="all" value="">
                      همه شهر ها
                    </option>
                    {cityList?.data?.map((c) => (
                      <option name={c.name} value={c.name}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </div> */}
                {/*-------------- dropdowns ------------ */}
                <div
                  className={
                    "w-full justify-around items-center flex flex-wrap md:flex-nowrap"
                  }
                >
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"عنوان مناسبت:"}
                    value={monasebat}
                    options={monasebatList?.data
                      .filter((item) => {
                        if (profile) {
                          return item.state === profile?.data.state;
                        } else {
                          return true;
                        }
                      })
                      .map((c) => ({
                        label: c.title,
                        value: c.id,
                      }))}
                    onChange={(e) => {
                      setCPage(null);
                      setMonasebat(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"شهر:"}
                    value={city}
                    options={cityList?.data
                      .filter((item) => {
                        if (state && state !== "") {
                          return item.state === state;
                        } else {
                          return true;
                        }
                      })
                      .map((c) => ({
                        label: c.name,
                        value: c.id,
                      }))}
                    onChange={(e) => {
                      setCPage(null);
                      setCity(e.value);
                    }}
                  />
                </div>
                <div
                  className={
                    "w-full justify-around items-center flex flex-wrap md:flex-nowrap"
                  }
                >
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"مجموعه:"}
                    value={department}
                    options={departmentList?.data.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setCPage(null);
                      setDepartment(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"سازمان:"}
                    value={sazman}
                    options={sazmanList?.data
                      .filter((i) => {
                        return department ? i.majmooe === department : true;
                      })
                      .map((c) => ({
                        label: c.title,
                        value: c.id,
                      }))}
                    onChange={(e) => {
                      setCPage(null);
                      setSazman(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"وضعیت"}
                    value={status}
                    options={[
                      { label: "انتظار بررسی", value: "انتظار بررسی" },
                      { label: "نیاز به ویرایش", value: "نیاز به ویرایش" },
                      { label: "تایید شده", value: "تایید شده" },
                      { label: "در انتظار اجرا", value: "در انتظار اجرا" },
                    ]}
                    onChange={(e) => {
                      setCPage(null);
                      setStatus(e.value);
                    }}
                  />
                </div>
                <div className={"w-full justify-around items-center flex"}>
                  <button
                    onClick={removeFilters}
                    className="cursor-pointer flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                  >
                    حذف فیلترها x
                  </button>
                </div>
              </div>
              <div className=" w-full space-y-3" userRole={UserRoles.Sazman}>
                <div className="relative form-field w-full flex items-center justify-center">
                  {renderSearch()}
                </div>
                {/* <div className={"w-full justify-around items-center flex"}>
                  <select
                    onChange={(e) => setStatus(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="month" value="">
                      همه وضعیت ها
                    </option>
                    <option name={"انتظار بررسی"} value={"انتظار بررسی"}>
                      انتظار بررسی
                    </option>
                    <option name={"نیاز به ویرایش"} value={"نیاز به ویرایش"}>
                      نیاز به ویرایش
                    </option>
                    <option name={"تایید شده"} value={"تایید شده"}>
                      تایید شده
                    </option>
                  </select>
                  <select
                    onChange={(e) => setDepartment(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="month" value="">
                      همه مجموعه
                    </option>
                    {departmentList?.data?.map((c) => (
                      <option name={c.title} value={c.title}>
                        {c.title}
                      </option>
                    ))}
                  </select>
                  <select
                    onChange={(e) => setState(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="all" value="">
                      همه شهر ها
                    </option>
                    {cityList?.data?.map((c) => (
                      <option name={c.name} value={c.name}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </div> */}
                {/*-------------- dropdowns ------------ */}
                <div
                  className={
                    "w-full justify-around items-center flex flex-wrap md:flex-nowrap"
                  }
                >
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    disabled={isSazmanOstan()}
                    label={"استان"}
                    value={state}
                    options={stateList?.data?.map((c) => ({
                      label: c.name,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setState(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"شهر:"}
                    value={city}
                    options={cityList?.data
                      .filter((item) => {
                        if (state && state !== "") {
                          return item.state === state;
                        } else {
                          return true;
                        }
                      })
                      .map((c) => ({
                        label: c.name,
                        value: c.id,
                      }))}
                    onChange={(e) => {
                      setCity(e.value);
                    }}
                  />
                </div>
                <div
                  className={
                    "w-full justify-around items-center flex flex-wrap md:flex-nowrap"
                  }
                >
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"عنوان مناسبت:"}
                    value={monasebat}
                    options={monasebatList?.data.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setMonasebat(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"سازمان:"}
                    value={sazman}
                    options={sazmanList?.data
                      .filter((i) => {
                        return department
                          ? i.majmooe === department
                          : majmooe !== 0
                            ? i.majmooe === majmooe
                            : true;
                      })
                      .map((c) => ({
                        label: c.title,
                        value: c.id,
                      }))}
                    onChange={(e) => {
                      setSazman(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"وضعیت"}
                    value={status}
                    options={[
                      { label: "انتظار بررسی", value: "انتظار بررسی" },
                      { label: "نیاز به ویرایش", value: "نیاز به ویرایش" },
                      { label: "تایید شده", value: "تایید شده" },
                      {
                        label: "در انتظار ثبت گزارش",
                        value: "در انتظار ثبت گزارش",
                      },
                      { label: "در انتظار اجرا", value: "در انتظار اجرا" },
                    ]}
                    onChange={(e) => {
                      setStatus(e.value);
                    }}
                  />
                </div>
                <div className={"w-full justify-around items-center flex"}>
                  <button
                    onClick={removeFilters}
                    className="cursor-pointer flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                  >
                    حذف فیلترها x
                  </button>
                </div>
              </div>
              <div
                className=" w-full space-y-3"
                userRole={UserRoles.SazmanOstan}
              >
                <div className="relative form-field w-full flex items-center justify-center">
                  {renderSearch()}
                </div>
                {/* <div className={"w-full justify-around items-center flex"}>
                  <select
                    onChange={(e) => setStatus(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="month" value="">
                      همه وضعیت ها
                    </option>
                    <option name={"انتظار بررسی"} value={"انتظار بررسی"}>
                      انتظار بررسی
                    </option>
                    <option name={"نیاز به ویرایش"} value={"نیاز به ویرایش"}>
                      نیاز به ویرایش
                    </option>
                    <option name={"تایید شده"} value={"تایید شده"}>
                      تایید شده
                    </option>
                  </select>
                  <select
                    onChange={(e) => setDepartment(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="month" value="">
                      همه مجموعه
                    </option>
                    {departmentList?.data?.map((c) => (
                      <option name={c.title} value={c.title}>
                        {c.title}
                      </option>
                    ))}
                  </select>
                  <select
                    onChange={(e) => setState(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="all" value="">
                      همه شهر ها
                    </option>
                    {cityList?.data?.map((c) => (
                      <option name={c.name} value={c.name}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </div> */}
                {/*-------------- dropdowns ------------ */}
                <div
                  className={
                    "w-full justify-around items-center flex flex-wrap md:flex-nowrap"
                  }
                >
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"عنوان مناسبت:"}
                    value={monasebat}
                    options={monasebatList?.data.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setMonasebat(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"شهر:"}
                    value={city}
                    options={cityList?.data
                      .filter((item) => {
                        if (profile) {
                          return item.state === profile?.data.state;
                        } else {
                          return true;
                        }
                      })
                      .map((c) => ({
                        label: c.name,
                        value: c.id,
                      }))}
                    onChange={(e) => {
                      setCity(e.value);
                    }}
                  />
                </div>
                <div
                  className={
                    "w-full justify-around items-center flex flex-wrap md:flex-nowrap"
                  }
                >
                  {/* { department && <button onClick={setDepartment("")} className="z-50 bg-red-200 rounded-full">Xdddddddddddddddddddddddd</button>} */}
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"سازمان:"}
                    value={sazman}
                    options={sazmanList?.data
                      .filter((i) => {
                        return department
                          ? i.majmooe === department
                          : majmooe !== 0
                            ? i.majmooe === majmooe
                            : true;
                      })
                      .map((c) => ({
                        label: c.title,
                        value: c.id,
                      }))}
                    onChange={(e) => {
                      setSazman(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"وضعیت"}
                    value={status}
                    options={[
                      { label: "انتظار بررسی", value: "انتظار بررسی" },
                      { label: "نیاز به ویرایش", value: "نیاز به ویرایش" },
                      { label: "تایید شده", value: "تایید شده" },
                      {
                        label: "در انتظار ثبت گزارش",
                        value: "در انتظار ثبت گزارش",
                      },
                      { label: "در انتظار اجرا", value: "در انتظار اجرا" },
                    ]}
                    onChange={(e) => {
                      setStatus(e.value);
                    }}
                  />
                </div>
                <div className={"w-full justify-around items-center flex"}>
                  <button
                    onClick={removeFilters}
                    className="cursor-pointer flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                  >
                    حذف فیلترها x
                  </button>
                </div>
              </div>
              <div className=" w-full space-y-3" userRole={UserRoles.ModireKol}>
                <div className="relative form-field w-full flex items-center justify-center">
                  {renderSearch()}
                </div>
                {/* <div className={"w-full justify-around items-center flex"}>
                  <select
                    onChange={(e) => setStatus(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="month" value="">
                      همه وضعیت ها
                    </option>
                    <option name={"انتظار بررسی"} value={"انتظار بررسی"}>
                      انتظار بررسی
                    </option>
                    <option name={"نیاز به ویرایش"} value={"نیاز به ویرایش"}>
                      نیاز به ویرایش
                    </option>
                    <option name={"تایید شده"} value={"تایید شده"}>
                      تایید شده
                    </option>
                  </select>
                  <select
                    onChange={(e) => setDepartment(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="month" value="">
                      همه مجموعه
                    </option>
                    {departmentList?.data?.map((c) => (
                      <option name={c.title} value={c.title}>
                        {c.title}
                      </option>
                    ))}
                  </select>
                  <select
                    onChange={(e) => setState(e.target.value)}
                    className=" w-[200px] p-3 rounded-lg"
                  >
                    <option name="all" value="">
                      همه شهر ها
                    </option>
                    {cityList?.data?.map((c) => (
                      <option name={c.name} value={c.name}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </div> */}
                {/*-------------- dropdowns ------------ */}
                <div
                  className={
                    "w-full justify-around items-center flex flex-wrap md:flex-nowrap"
                  }
                >
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    disabled={isSazmanOstan()}
                    label={"استان"}
                    value={state}
                    options={stateList?.data?.map((c) => ({
                      label: c.name,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setState(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"شهر:"}
                    value={city}
                    options={cityList?.data
                      .filter((item) => {
                        if (state && state !== "") {
                          return item.state === state;
                        } else {
                          return true;
                        }
                      })
                      .map((c) => ({
                        label: c.name,
                        value: c.id,
                      }))}
                    onChange={(e) => {
                      setCity(e.value);
                    }}
                  />
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"مجموعه:"}
                    value={department}
                    options={departmentList?.data.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setDepartment(e.value);
                    }}
                  />
                </div>
                <div
                  className={
                    "w-full justify-around items-center flex flex-wrap md:flex-nowrap"
                  }
                >
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"سازمان:"}
                    value={sazman}
                    options={sazmanList?.data
                      .filter((i) => {
                        return department ? i.majmooe === department : true;
                      })
                      .map((c) => ({
                        label: c.title,
                        value: c.id,
                      }))}
                    onChange={(e) => {
                      setSazman(e.value);
                    }}
                  />

                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"عنوان مناسبت:"}
                    value={monasebat}
                    options={monasebatList?.data.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setMonasebat(e.value);
                    }}
                  />

                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"وضعیت"}
                    value={status}
                    options={[
                      { label: "انتظار بررسی", value: "انتظار بررسی" },
                      { label: "نیاز به ویرایش", value: "نیاز به ویرایش" },
                      { label: "تایید شده", value: "تایید شده" },
                      {
                        label: "در انتظار ثبت گزارش",
                        value: "در انتظار ثبت گزارش",
                      },
                      { label: "در انتظار اجرا", value: "در انتظار اجرا" },
                    ]}
                    onChange={(e) => {
                      setStatus(e.value);
                    }}
                  />
                </div>
                <div className={"w-full justify-around items-center flex"}>
                  <button
                    onClick={removeFilters}
                    className="cursor-pointer flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                  >
                    حذف فیلترها x
                  </button>
                </div>
              </div>
            </RoleViewSelector>
          </div>
        </div>

        <Table
          loading={loading}
          data={data}
          hasPagination
          totalPageCount={totalPageCount}
          totalCount={programsObj?.data.count}
          setPage={setTablePage}
          currentPage={currentPage}
          header={tableHeader}
        />
      </div>
    </MainLayout>
  );
};

export default ProgramListPage;
